import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchBranch, fetchProductType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const ProductTypeDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const branchName = getValues().product_type;
  const selectedBranch = watch("product_type_id");

  const {
    data: branches,
    isLoading,
    error,
  } = useQuery(["product-type"], () => fetchProductType(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(
    () =>
      branches?.data?.data?.map((branch) => ({
        value: branch.id,
        label: branch.product_type,
      })) || [],
    [branches]
  );

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.product_type_id
      );
      setValue("product_type_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  const selectedOption = options.find(
    (option) => option.value === selectedBranch || branchName
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Branches</div>;

  return (
    <Controller
      name="product_type_id"
      control={control}
      rules={{
        required: required ? "Product type is required" : false,
        validate: (value) => {
          if (required && !value) return "Product type is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Product Type"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("product_type_id", value);
          }}
          className={`react-select-container ${
            errors.branch_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default ProductTypeDropdown;
